import { Injectable, Input } from '@angular/core';

import { Card } from '../../../interfaces/card';
import { CardColumnSelectionBase } from './card-column-selection-base';

@Injectable()
export abstract class CardColumnBase {
  constructor() {}

  // Selection is optional.
  @Input() selectionModel: CardColumnSelectionBase | null = null;

  @Input() title: string = '';
  @Input() message: string = '';

  // This enables a text box at the top of the modal which allows the user to filter the displayed options
  // by the label.
  @Input() enableFiltering: boolean = false;
  filterText: string = '';

  // Overrideable function for filtering cards
  filter(text: string) {}

  // Overrideable function for clearing filter
  clearFilter() {}

  // Overrideable function to handle card click event.
  cardClicked(Card: Card) {}
}
